// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_kLq","cls2":"ReferenceEvaluationPage-cls2_4kM ReferenceEvaluationPage-cls1_kLq"};